import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";

import "./social-auth-link.scss";

const block = "social-auth-link";

const SocialAuthLink = ({ text, href, className, onClick }) => (
  <a
    onClick={onClick}
    href={href}
    target="_self"
    className={cn(block, className)}
  >
    <div className={`${block}__wrapper`}>
      <img
        className={`${block}__icon`}
        src="https://d1plv6l29cfunh.cloudfront.net/images/btn_google_light_normal_ios.svg"
        aria-hidden="true"
        alt=""
      />
      <span className={`${block}__text`}>{text}</span>
    </div>
  </a>
);

SocialAuthLink.propTypes = {
  text: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func
};

export default SocialAuthLink;
